import SetCurrentComponent from "@/core/services/SetCurrentComponent";

const consulta_de_alunos_com_reserva_de_vagas_web = {
  path: "/consulta-de-alunos-com-reserva-de-vagas-web",
  redirect: "/consulta-de-alunos-com-reserva-de-vagas-web",
  meta: {
    breadCrumb: "Atendimento ao Aluno - Manutenção de Aluno",
  },
  children: [
    {
      path: "/consulta-de-alunos-com-reserva-de-vagas-web",
      name: "consulta_de_alunos_com_reserva_de_vagas_web",
      component: SetCurrentComponent(
        "ConsultaDeAlunosComReservaDeVagasWeb",
        "ConsultaDeAlunosComReservaDeVagasWebHome"
      ),
    },
    {
      path: "/consulta-de-alunos-com-reserva-de-vagas-web/visualizar/:id",
      name: "consulta_de_alunos_com_reserva_de_vagas_web_visualizar",
      component: SetCurrentComponent(
        "ConsultaDeAlunosComReservaDeVagasWeb",
        "ConsultaDeAlunosComReservaDeVagasWebVisualizar"
      ),
    },
  ],
};

export { consulta_de_alunos_com_reserva_de_vagas_web };
